module.exports = __webpack_public_path__ + "img/Qiehuan.d678895d.svg";